export default "__VITE_ASSET__CVxKhm4y__"